module.exports = __webpack_public_path__ + "static/media/icon_app_store_en.3bd19997.png";